import React from 'react';
import ProductOwnerLogin from './ProductOwnerLogin';

const ProductOwnerConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
				leftSidePanel: { display: false },
				rightSidePanel: { display: false },
				announcement: { display: false },
			},
		},
	},
	routes: [
		{
			path: '/product-owner/login',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ProductOwnerLogin />
				</React.Suspense>
			),
		},
	],
};

export default ProductOwnerConfig;
